import {
  Box,
  Text,
  Button,
  SimpleGrid,
  Progress,
  Tooltip,
} from '@wegroup/design-system';
import React from 'react';
import Stats from './Stats/Stats';
import { parse } from 'query-string';
import { useHistory, useLocation } from 'react-router';

import { useFlowsSelector } from '../../../../common/src/utils/globalVariables';
import useFlowQuestions from '../../hooks/useFlowQuestions';
import { useFlowsRouteParams } from '../../hooks/useFlowsRouteParams';

const DevToolsIntro: React.FC<React.PropsWithChildren<unknown>> = () => {
  const location = useLocation();
  const history = useHistory();
  const { lastRoute } = parse(location.search);
  const { flowId, sessionId } = useFlowsRouteParams();

  const questionnaire = useFlowsSelector((state) => state.flows.questionnaire);
  const answers = useFlowsSelector((state) => state.flows.answers);
  const questions = useFlowQuestions();

  const goBack = () => {
    if (lastRoute) {
      if (typeof lastRoute === 'string') history.push(lastRoute);
      else history.push(lastRoute[0]);
    } else {
      history.push(`/flows/${flowId}/questions/${sessionId}/0`);
    }
  };

  return (
    <>
      <Text mb="6" textStyle="h1Headline">
        Welcome to the LouiseV2 dev tools
      </Text>
      <Text textStyle="h5Headline">Flow progress:</Text>
      <Progress
        mt="4"
        w="100%"
        value={Math.round((answers.length / questions.length) * 100)}
      />
      <Box w="100%">
        <Stats
          statsData={[
            {
              label: 'Amount of groups',
              value: questionnaire.groups.length.toString(),
            },
            {
              label: 'Amount of questions',
              value: questions.length.toString(),
            },
            { label: 'Answered questions', value: answers.length.toString() },
          ]}
        />
      </Box>

      <SimpleGrid columns={3} spacing={12} mb="8">
        <Tooltip
          hasArrow
          label="Easily hop to specific questions troughout the current flow."
        >
          <Button
            onClick={() =>
              history.push(
                `/flows/${flowId}/devtools/${sessionId}/hopper?lastRoute=${lastRoute}`,
              )
            }
          >
            Go to question hopper tool
          </Button>
        </Tooltip>
        <Tooltip
          hasArrow
          label="Let the flow progress automatically to a specific question by filling in dummy data and sending it to BE. This will result in a valid and useable flow."
        >
          <Button
            onClick={() =>
              history.push(
                `/flows/${flowId}/devtools/${sessionId}/progressor?lastRoute=${lastRoute}`,
              )
            }
          >
            Go to flow progressor tool
          </Button>
        </Tooltip>
      </SimpleGrid>

      <Button onClick={goBack}>Go back</Button>
    </>
  );
};

export default DevToolsIntro;
